import createSafeContext from '#/utils/createSafeContext';

import type { OpenPosition } from '#/api/positions';

export const [usePosition, PositionProvider] =
  createSafeContext<OpenPosition>('Position');
